import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DtoTabla } from '../../util/dtoTabla';
import { UsuarioActual } from 'src/app/util/usuarioactual';
import { JWT_RESPONSE_HEADER } from './constantes';

@Injectable()
export class UsuarioPublicService {

    private url = `${this.config.getEnv('proxy')}public/seguridad/usuario/`;

    constructor(private http: HttpClient, private config: AppConfig) { }

    listarCompanias(usuario: string): Promise<DtoTabla[]> {

        const params = new HttpParams().set('idUsuario', usuario);

        return this.http.get(`${this.url}listarCompanias`, { params })
            .toPromise()
            .then(response => response as DtoTabla[])
            .catch(error => []);
    }

    login(username: string, password: string, compania: string): Promise<any> {
        var ua = new UsuarioActual();
        ua.usuarioLogin = username;
        ua.clave = password;
        ua.companiaSocioCodigo = compania;
        ua.aplicacionCodigo = 'AA';

        return this.http.post(`${this.url}login`, ua)
            .toPromise()
            .then(response => this.saveToken(response as UsuarioActual))
            .catch(error => null);
    }

    private saveToken(res: UsuarioActual): any {
        const token = res.token;
        if (token) {
            sessionStorage.setItem(JWT_RESPONSE_HEADER, token);
        }
        return res;
    }

    // public obtenerMenu(usuario:string ): Promise<any> {
    //     const params = new HttpParams().set('usuario', usuario)
    //     return this.http.get(`${this.url}obtenerMenu`, { params })        
    //         .toPromise()
    //         .then(response => response as any)
    //         .catch(error => new Object());
    // }   

    // public obtenerUsuarioActual(usuario:string ): Promise<UsuarioActual> {
    //     const params = new HttpParams().set('usuario', usuario)
    //     return this.http.get(`${this.url}obtenerUsuarioActual`, { params })        
    //         .toPromise()
    //         .then(response => response as any)
    //         .catch(error => new UsuarioActual());
    // } 


    // public enviarRecuperarClave(correo: string): Promise<any> {

    //     var dtoCorreo: DtoCorreo = new DtoCorreo();
    //     dtoCorreo.correo = correo;

    //     return this.http.post(`${this.url}api/Usuario/enviarRecuperarClave`, dtoCorreo)
    //         .toPromise()
    //         .then(response => (response as any).mensaje as string)
    //         .catch(error => null);
    // }
    firmarDocumento(dto: DtoDocumentoFirmar): Promise<DtoDocumentoFirmar> {
        return this.http.post(`${this.url}firmarDocumento`, dto)
            .toPromise()
            .then(response => response as DtoDocumentoFirmar)
            .catch(error => null);
    }
}

export class DtoCorreo {
    empleado: number;
    compania: string;
    correo: string;
}
export class DtoDocumentoFirmar {
    pdfBase64: string;
    imagenBase64: string;
    resultadoBase64: string;
}

